import { Row } from "@faire/web/slate/Layout";
import { LoadingSpinner } from "@faire/web/slate/LoadingSpinner";
import React from "react";
export var CenteredLoadingSpinner = function CenteredLoadingSpinner() {
  return /*#__PURE__*/React.createElement(Row, {
    justify: "center",
    align: "center"
  }, /*#__PURE__*/React.createElement(LoadingSpinner, null));
};